
import TransitionAccordion from './transitions/TransitionAccordion'

export default {
  name: 'FaqList',
  components: { TransitionAccordion },
  props: {
    faqItems: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      activeItem: -1
    }
  }
}
